export default __webpack_public_path__ + "media/images/favicon/apple-touch-icon-114x114-eaf87d27c6d80f858518ebb18d4a1868.png";